import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, getCurrentInstance } from 'vue'
import deepEqual from 'deep-equal'
import { MissionUi } from '@/models/ui/MissionUi'
import { IrisConfigContainer } from '@/models/iris/IrisConfigContainer'
import { ISendMailConfig } from '@/models/iris/sendMail/ISendMailConfig'
import { VuetifyConfirmObject } from 'vuetify-confirm'
import { AloMission } from '@/models/alo/AloMission'
import store from '@/store'
import { i18n } from '@/locale/vueI18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'MissionDetailSendMail',
  props: {
    mission: null
  },
  setup(__props: any) {

const props = __props as {
  mission: AloMission
};


// Accès aux plugins Vue via l'instance (Vue 2 + Composition API)
const instance = getCurrentInstance()
const $confirm = instance?.proxy?.$confirm!

const new_mails_glider_alr = ref('')
const new_mails_iris_alr = ref('')
const new_mails_surfacing = ref('')
const new_mails_detection = ref('')

const config = ref({
  enableSendMail: true,
  SendMail_mailling: {
    mails_glider_alr: [] as string[],
    mails_iris_alr: [] as string[],
    mails_surfacing: [] as string[],
    mails_detection: [] as string[],
  },
})

const nextSurfacingCmd = ref('')
const allSurfacingCmd = ref('')

const showDetection = computed(() => store.myGetters.userProfile?.config?.postprocess_image ?? false)

const loading = computed(() => store.myGetters.sendMailLoading)
const status = computed(() => store.myGetters.gliderStatus)
const originalSendMailConfig = computed(() => store.myGetters.originalSendMailConfigs[props.mission.misId!])
const modifiedSendMailConfig = computed(() => store.myGetters.modifiedSendMailConfigs[props.mission.misId!])

const btnActif = computed(() => {
  const configCopy = {
    SendMail_mailling: {
      mails_glider_alr: [] as string[],
      mails_iris_alr: [] as string[],
      mails_surfacing: [] as string[],
      mails_detection: [] as string[],
    },
  }
  loadConfig(configCopy, originalSendMailConfig.value)
  return !deepEqual(configCopy, config.value) && !loading.value
})

function removeMail(mail: string, mails: string[]) {
  const idx = mails.indexOf(mail)
  if (idx > -1) {
    $confirm(i18n.t('Pilot.SendMail.DeleteMailDialogMessage').toString(), {
      title: i18n.t('Admin.Warning'),
    } as VuetifyConfirmObject).then((answer: boolean | undefined) => {
      if (answer) mails.splice(idx, 1)
    })
  }
}

function addMail(mail: string, mails: string[]) {
  if (mail.length > 0) {
    if (mails.indexOf(mail) == -1) {
      mails.push(mail)
    }
  }
}

function addNewMailGlider() {
  addMail(new_mails_glider_alr.value, config.value.SendMail_mailling.mails_glider_alr)
  new_mails_glider_alr.value = ''
}

function removeGliderMail(mail: string) {
  removeMail(mail, config.value.SendMail_mailling.mails_glider_alr)
}

function addNewMailIris() {
  addMail(new_mails_iris_alr.value, config.value.SendMail_mailling.mails_iris_alr)
  new_mails_iris_alr.value = ''
}

function removeIrisMail(mail: string) {
  removeMail(mail, config.value.SendMail_mailling.mails_iris_alr)
}

function addNewMailSurfacing() {
  addMail(new_mails_surfacing.value, config.value.SendMail_mailling.mails_surfacing)
  new_mails_surfacing.value = ''
}

function removeSurfacingMail(mail: string) {
  removeMail(mail, config.value.SendMail_mailling.mails_surfacing)
}

function addNewMailDetection() {
  addMail(new_mails_detection.value, config.value.SendMail_mailling.mails_detection)
  new_mails_detection.value = ''
}

function removeDetectionMail(mail: string) {
  removeMail(mail, config.value.SendMail_mailling.mails_detection)
}

function loadConfig(target: any, configData: IrisConfigContainer<ISendMailConfig>) {
  if (configData) {
    target.enableSendMail = configData.mod_settings.EnabledMOD['module-SendMail']
    target.SendMail_mailling = {
      ...target.SendMail_mailling,
      ...configData.mod_settings.SendMail_mailling,
    }
  }
}

function validateConfig() {
  store.myActions.MISSION_UPDATE_MODIFIED_SEND_MAIL({
    itemId: props.mission.misId!,
    newProperties: {
      mod_settings: {
        EnabledMOD: {
          'module-SendMail': config.value.enableSendMail,
        },
        SendMail_mailling: {
          ...config.value.SendMail_mailling,
        },
      },
    },
  })
}

function saveConfig() {
  validateConfig()
  store.myActions.MISSION_IRIS_SEND_MAIL_SAVE_REQUEST(props.mission.misId!)
}

function restoreConfig() {
  store.myActions.MISSION_CANCEL_MODIFIED_SEND_MAIL(props.mission.misId!)
}

// Watch for mission changes
watch(
  () => props.mission,
  newValue => {
    if (newValue.misId != null) {
      store.myActions.MISSION_IRIS_SEND_MAIL_REQUEST(newValue.misId)
    }
  },
)

// Watch for modifiedSendMailConfig changes
watch(modifiedSendMailConfig, (newConfig: IrisConfigContainer<ISendMailConfig>) => {
  loadConfig(config.value, newConfig)
})

// Watch for config changes
watch(
  config,
  () => {
    validateConfig()
  },
  { deep: true },
)

// Created lifecycle
if (props.mission.misId != null) {
  store.myActions.MISSION_IRIS_SEND_MAIL_REQUEST(props.mission.misId!).then(() => {
    loadConfig(config.value, modifiedSendMailConfig.value)
  })
}

return { __sfc: true,props, instance, $confirm, new_mails_glider_alr, new_mails_iris_alr, new_mails_surfacing, new_mails_detection, config, nextSurfacingCmd, allSurfacingCmd, showDetection, loading, status, originalSendMailConfig, modifiedSendMailConfig, btnActif, removeMail, addMail, addNewMailGlider, removeGliderMail, addNewMailIris, removeIrisMail, addNewMailSurfacing, removeSurfacingMail, addNewMailDetection, removeDetectionMail, loadConfig, validateConfig, saveConfig, restoreConfig }
}

})